import { Component, OnInit, Input, OnDestroy, OnChanges, Output } from '@angular/core';
import { Contact } from 'src/classes/contact';
import { ContactService } from 'src/services/contact/contact.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import generateRandomPassword from 'src/utils/generateRandomPassword';

@Component({
  selector: 'app-bulk-send-pdf-password-modal',
  templateUrl: './bulk-send-pdf-password-modal.component.html',
  styleUrls: ['./bulk-send-pdf-password-modal.component.scss']
})
export class BulkSendPdfPasswordModalComponent implements OnInit, OnChanges, OnDestroy {

  @Input() contacts: Contact[] = [];

  public exists: boolean;
  public inProgress = false;
  public progress = 0;
  public errorList: {contactName: string, contactEmail: string, message: string}[] = [];
  public pdfLessContacts: Contact[];
  public pdfLessAction: null | 'create' | 'skip';
  public showPdfLessContacts = false;
  public hasChangedContacts = false;

  constructor(
    public activeModal: NgbActiveModal,
    private contactService: ContactService
  ) { }

  ngOnInit() {
    this.exists = true;
    if (this.contacts.length && !this.inProgress) {
      this.pdfLessContacts = this.getPdfLessContacts();

      if (this.pdfLessContacts.length === 0) {
        this.inProgress = true;
        this.startProgress();
      }
    }
  }

  /**
   * Get a list of all contacts without pdf password
   */
  getPdfLessContacts() {
    return this.contacts.filter(contact => !contact.pdfpassword);
  }

  ngOnDestroy() {
    this.exists = false;
  }

  ngOnChanges(change) {
    if (change.contacts) {
      if (!this.inProgress) {
        this.pdfLessContacts = this.getPdfLessContacts();

        if (this.pdfLessContacts.length === 0) {
          this.inProgress = true;
          this.startProgress();
        }
      }
    }
  }

  addError(contact: Contact, message: string) {
    let contactName = contact && contact.name ? contact.name : 'Unknown';
    if (contact && contact.email && contact.email.includes('@') && contact.email.length > 50) {
      contactName += ` <${contact.email.substring(0, contact.email.indexOf('@'))}...>`;
    } else if (contact && typeof contact.email === "string") {
      contactName += ` <${contact.email}>`;
    }
    contactName += '\n\t';
    let contactEmail = contact.email;
    this.errorList.push({contactName, contactEmail, message});
  }

  async startProgress() {
    this.progress = 0;
    this.errorList = [];

    let i = 0;
    const maxConsecutivePromises = 3;
    let activePromises = 0;

    await new Promise(resolve => setTimeout(resolve, 1000));

    while (this.exists && i < this.contacts.length) {
      while (activePromises >= maxConsecutivePromises) {
        await new Promise(resolve => setTimeout(resolve, 250));
        if (!this.exists) {
          return;
        }
      }
      const contact = this.contacts[i];
      this.sendEmailWithPasswordClick(contact).then(() => {
        activePromises--;
        this.progress += 1/this.contacts.length;
      }).catch((err) => {
        activePromises--;
        this.addError(contact, typeof err === 'object' ? err.message : err);
        this.progress += 1/this.contacts.length;
        console.log(this.progress);
      });
      activePromises++;
      i++;
    }

    while (activePromises > 0) {
      await new Promise(resolve => setTimeout(resolve, 250));
      if (!this.exists) {
        return;
      }
    }

    this.inProgress = false;
    this.progress = 1;
  }

  onPdfLessActionClick(type: 'create' | 'skip') {
    this.pdfLessAction = type;

    if (!this.inProgress) {
      this.inProgress = true;
      this.startProgress();
    }
  }

  get contactCount() {
    if (this.pdfLessAction !== 'skip') {
      return this.contacts.length;
    }
    return this.contacts.filter(c => c.pdfpassword).length;
  }

  onListMissingContactClick() {
    this.showPdfLessContacts = !this.showPdfLessContacts;
  }

  onCancelClick() {
    this.exists = false;
    this.activeModal.close(this.hasChangedContacts);
  }

  async sendEmailWithPasswordClick(contact: Contact): Promise<void> {
    if (typeof contact !== 'object') {
      throw new Error(`Contact must be of type 'object', got '${typeof contact}'`);
    }
    if (!contact.email || !contact.email.includes('@')) {
      throw new Error('Contact email is invalid');
    }
    if (!contact.pdfpassword) {
      if (this.pdfLessAction === 'skip') {
        return;
      } else if (this.pdfLessAction === 'create') {
        contact.pdfpassword = generateRandomPassword();
        await this.contactService.editContact(contact);
        this.hasChangedContacts = true;
      }
      if (!contact.pdfpassword) {
        throw new Error('Contact does not have a registered PDF password');
      }
    }
    // if (true === await new Promise(resolve => setTimeout(resolve.bind(this, Math.random() > 0.5), 3000+Math.random()*1000))) {
    if (true === await this.contactService.sendPdfPassword(contact.email, contact.pdfpassword)) {
      return;
    }
    throw new Error('Server did not send an indication of success');
  }

}
